import {mappingExams, mappingApplicantExams} from '@helpers/mapping_fields';
import {getRequest, saveRequest, removeRequest} from '@requests/index';
import {addNotification, loadingApplication} from '@componentDP/js_react/redux/actions/application';
import {findApplicantExamIndex} from '@helpers/find';
import {
    SET_EXAMS,
    OPEN_EXAM_EDIT,
    CLOSE_EXAM_EDIT,
    SET_EXAM_EDIT,
    RESET_EXAM_EDIT,
    SET_APPLICANT_EXAMS,
    RESET_EXAM_DELETE,
    SET_EXAM_DELETE,
    OPEN_EXAM_DELETE,
    CLOSE_EXAM_DELETE,
} from '../store/actionTypes';

export const setExams = (exams) => {
    exams = mappingExams(exams);
    return (dispatch) => {
        dispatch({
            type: SET_EXAMS,
            payload: exams,
        });
    };
};

export const openExamEdit = (id, t) => {
    return (dispatch, getState) => {
        if (id === 0) {
            dispatch(resetExamEdit());
            dispatch({
                type: OPEN_EXAM_EDIT,
            });
        } else {
            const {applicantExams} = getState();
            const applicantExamIndex = findApplicantExamIndex(applicantExams, id);
            if (applicantExamIndex !== -1) {
                dispatch(setExamEdit(applicantExams[applicantExamIndex]));
                dispatch({
                    type: OPEN_EXAM_EDIT,
                });
            } else {
                dispatch(addNotification({message: t('not_found_entrance_test'), type: 'error'}));
            }
        }
    };
};

export const closeExamEdit = () => {
    return (dispatch) => {
        dispatch({
            type: CLOSE_EXAM_EDIT,
        });
        dispatch(resetExamEdit());
    };
};

export const setExamEdit = (examEdit) => {
    return (dispatch) => {
        dispatch({
            type: SET_EXAM_EDIT,
            payload: examEdit,
        });
    };
};

export const saveEditExam = (t) => {
    return async (dispatch, getState) => {
        try {
            dispatch(loadingApplication(true));
            const {apiDomainVikon, examEdit, zajavls} = getState();
            const saveApplicantExamResult = await saveRequest(
                `${apiDomainVikon}api/digital_profile/applicant_exam`,
                examEdit,
            );
            if (saveApplicantExamResult.errors) {
                throw new Error(saveApplicantExamResult.errors);
            }
            dispatch(closeExamEdit());
            const applicantExams = await getRequest(`${apiDomainVikon}api/digital_profile/applicant_exam`);
            if (applicantExams.errors) {
                throw new Error(applicantExams.errors);
            }
            dispatch(setApplicantExams(applicantExams));
            dispatch(addNotification({message: t('saved'), type: 'success'}));
            if (zajavls.length > 0) {
                dispatch(addNotification({message: t('need_to_resend_info'), type: 'info'}));
            }
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
};

export const setApplicantExams = (applicantExams) => {
    applicantExams = mappingApplicantExams(applicantExams);
    return (dispatch) => {
        dispatch({
            type: SET_APPLICANT_EXAMS,
            payload: applicantExams,
        });
    };
};

export const setExamDelete = (examDelete) => {
    return (dispatch) => {
        dispatch({
            type: SET_EXAM_DELETE,
            payload: examDelete,
        });
    };
};

export const openExamDelete = (id, t) => {
    return (dispatch, getState) => {
        const {applicantExams} = getState();
        const applicantExamIndex = findApplicantExamIndex(applicantExams, id);
        if (applicantExamIndex !== -1) {
            dispatch(setExamDelete(applicantExams[applicantExamIndex]));
            dispatch({
                type: OPEN_EXAM_DELETE,
            });
        } else {
            dispatch(addNotification({message: t('not_found_entrance_test'), type: 'error'}));
        }
    };
};

export const closeExamDelete = () => {
    return (dispatch) => {
        dispatch({
            type: CLOSE_EXAM_DELETE,
        });
        dispatch(resetExamDelete());
    };
};

export const deleteExamDelete = (t) => {
    return async (dispatch, getState) => {
        try {
            dispatch(loadingApplication(true));
            const {apiDomainVikon, examDelete, zajavls} = getState();
            const deleteApplicantExamResult = await removeRequest(
                `${apiDomainVikon}api/digital_profile/applicant_exam`,
                examDelete.id,
            );
            if (deleteApplicantExamResult.errors) {
                throw new Error(deleteApplicantExamResult.errors);
            }
            dispatch(closeExamDelete());
            const applicantExams = await getRequest(`${apiDomainVikon}api/digital_profile/applicant_exam`);
            if (applicantExams.errors) {
                throw new Error(applicantExams.errors);
            }
            dispatch(setApplicantExams(applicantExams));
            dispatch(addNotification({message: t('deleted'), type: 'success'}));
            if (zajavls.length > 0) {
                dispatch(addNotification({message: t('need_to_resend_info'), type: 'info'}));
            }
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
};

const resetExamEdit = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_EXAM_EDIT,
        });
    };
};

const resetExamDelete = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_EXAM_DELETE,
        });
    };
};
